import * as React from 'react';
import { NavigationConfig } from '../utils/navigation_config';
import LoginSignup from '../pages/loginSignup';
import CheckAuth from '../core/authentication';
import PermissionGuard from '../core/PermissionGuard';
import DefaultLanding from '../pages/DefaultLanding';
import Support from '../pages/support/Support';
import AdminManagementTabs from '../pages/adminManagement/AdminManagementTabs';
import UserManagement from '../pages/userManagement/UserManagement';
import PortalSetup from '../pages/portalSetup/PortalSetup';
import PortalDetailPage from '../pages/portalSetup/portalDetail/PortalDetailPage';
import MarketingContent from '../pages/marketingContent/MarketingContent';
import ResubmitApplication from '../pages/resubmitApplication/ResubmitApplication';
import DealerProgramAssocation from '../pages/dealerProgramAssocation/DealerProgramAssocation';
import ProgramManagement from '../pages/ProgramManagement/ProgramManagement';
import CreateApplication from '../pages/createApplication/CreateApplication';
import GlobalSettings from '../components/GlobalSettings/GlobalSettings';
import ChatbotConfig from '../components/GlobalSettings/ChatbotConfig';
import BacklogApplication from '../pages/backlogApplication/BacklogApplication';
import BacklogAppDetails from '../pages/backlogApplication/BacklogAppDetails';
import FundingLogManagement from '../pages/backlogApplication/fundingLog/FundingLogManagement';
import CustomerPortalDashboard from '../pages/customerPortal/dashboard';
import CustomerPortalUserManagement from '../pages/customerPortal/userManagement';
import CustomerPortalPaymentManagement from '../pages/customerPortal/paymentManagement';
import CustomerPortalDocumentManagement from '../pages/customerPortal/documentManagement';
import CustomerPortalDocumentTypeAccess from '../pages/customerPortal/documentTypeAccess';
import CustomerPortalDocumentSize from '../pages/customerPortal/documentSize';
import CustomerPortalSupportManagement from '../pages/customerPortal/supportManagement';
import CustomerPortalBrandCustomization from '../pages/customerPortal/brandCustomization';
import CustomerPortalFaqManagement from '../pages/customerPortal/genericfaqManagement';
import CustomerPortalAuditLogs from '../pages/customerPortal/auditLogs';
import CustomerPortalRegistrationManagement from '../pages/customerPortal/registrationManagement';
import RolesPermissions from '../pages/rolesPermissions/RolesPermissions';
import BacklogReducer from '../reducers/backlog_reducer';
import RouteErrorBoundary from '../components/RouteErrorBoundary/RouteErrorBoundary';
var navConfig = NavigationConfig;
var routes = [
    {
        path: '/',
        element: React.createElement(CheckAuth, null,
            React.createElement(DefaultLanding, null))
    },
    {
        path: navConfig.Dashboard,
        element: React.createElement(CheckAuth, null,
            React.createElement(DefaultLanding, null))
    },
    {
        path: navConfig.DealerManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:PORTAL_SETUP" },
                React.createElement(PortalSetup, null)))
    },
    {
        path: navConfig.DealerProgramAssocation,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:PORTAL_SETUP:DEALER_PROGRAM_ASSOCIATION" },
                React.createElement(DealerProgramAssocation, null)))
    },
    {
        path: "".concat(navConfig.DealerManagement, "/create"),
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT", requiredAccess: "Add" },
                React.createElement(PortalDetailPage, { mode: "create" })))
    },
    {
        path: "".concat(navConfig.DealerManagement, "/view/:id"),
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT" },
                React.createElement(PortalDetailPage, null)))
    },
    {
        path: "".concat(navConfig.DealerManagement, "/edit/:id"),
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT", requiredAccess: "Update" },
                React.createElement(PortalDetailPage, { initialEdit: true })))
    },
    {
        path: navConfig.UserManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "USER_MANAGMENT" },
                React.createElement(UserManagement, null)))
    },
    {
        path: navConfig.AdminManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:ADMIN_MGMT" },
                React.createElement(AdminManagementTabs, null)))
    },
    {
        path: navConfig.RolesPermissions,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:ADMIN_MGMT:ROLES_PERMISSIONS" },
                React.createElement(RolesPermissions, null)))
    },
    {
        path: navConfig.ResubmitApplication,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:RESUBMIT_APPLICATION" },
                React.createElement(ResubmitApplication, null)))
    },
    {
        path: navConfig.Support,
        element: React.createElement(CheckAuth, null,
            React.createElement(Support, null))
    },
    {
        path: navConfig.MarketingConent,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "MARKETING_CONTENT" },
                React.createElement(MarketingContent, null)))
    },
    {
        path: navConfig.ProgramManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:PORTAL_SETUP:PROGRAM_MGMT" },
                React.createElement(ProgramManagement, null)))
    },
    {
        path: navConfig.CreateApplication,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "APPLICATION_MANAGMENT", requiredAccess: "Add" },
                React.createElement(CreateApplication, null)))
    },
    {
        element: React.createElement(BacklogReducer, null),
        children: [
            {
                path: navConfig.BacklogManagement,
                element: React.createElement(CheckAuth, null,
                    React.createElement(PermissionGuard, { requiredPermission: "APPLICATION_MANAGMENT" },
                        React.createElement(BacklogApplication, null)))
            },
            {
                path: navConfig.FundingLogManagement,
                element: React.createElement(CheckAuth, null,
                    React.createElement(PermissionGuard, { requiredPermission: "APPLICATION_MANAGMENT" },
                        React.createElement(FundingLogManagement, null)))
            },
            {
                path: "".concat(navConfig.BacklogAppDetails, "/:id"),
                element: React.createElement(CheckAuth, null,
                    React.createElement(PermissionGuard, { requiredPermission: "APPLICATION_MANAGMENT" },
                        React.createElement(BacklogAppDetails, null)))
            },
        ]
    },
    {
        path: navConfig.InsuranceConfig,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:GLOBAL_SETTINGS" },
                React.createElement(GlobalSettings, null)))
    },
    {
        path: navConfig.ChatbotConfig,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "ADMINISTRATOR:GLOBAL_SETTINGS:CHATBOT_FAQS" },
                React.createElement(ChatbotConfig, null)))
    },
    {
        path: navConfig.CustomerPortalDashboard,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalDashboard, null)))
    },
    {
        path: navConfig.CustomerPortalUserManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalUserManagement, null)))
    },
    {
        path: navConfig.PaymentManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalPaymentManagement, null)))
    },
    {
        path: navConfig.DocumentManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalDocumentManagement, null)))
    },
    {
        path: navConfig.DocumentTypeAccess,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalDocumentTypeAccess, null)))
    },
    {
        path: navConfig.DocumentSize,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalDocumentSize, null)))
    },
    {
        path: navConfig.CustomerPortalSupportManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalSupportManagement, null)))
    },
    {
        path: navConfig.BrandCustomization,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalBrandCustomization, null)))
    },
    {
        path: navConfig.CustomerPortalChatbotFaqs,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL:BRAND_CUSTOMIZATION:CHATBOT_FAQS" },
                React.createElement(CustomerPortalFaqManagement, { heading: "Chatbot FAQs", permission: "chatbotFaqs" })))
    },
    {
        path: navConfig.CustomerPortalAuditLogs,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalAuditLogs, null)))
    },
    {
        path: navConfig.CustomerPortalRegistrationManagement,
        element: React.createElement(CheckAuth, null,
            React.createElement(PermissionGuard, { requiredPermission: "CUSTOMER_PORTAL" },
                React.createElement(CustomerPortalRegistrationManagement, null)))
    },
    {
        path: '/*',
        element: React.createElement(LoginSignup, null)
    }
];
export var main_routes = [
    {
        errorElement: React.createElement(RouteErrorBoundary, null),
        children: routes,
    }
];
